import styled from 'styled-components';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import Lottie from 'react-lottie-player';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const ShortFormBtnOld = styled(Button)`
  overflow: hidden;
  width: 40px;
  height: 40px;
  border-radius: 100%;
  background: linear-gradient(135deg, #ff3d22 0%, #f01478 100%);

  @media ${({ theme }) => theme.media.smMax} {
    width: ${mixin.pxToVw('40')};
    height: ${mixin.pxToVw('40')};
  }
`;

export const ShortFormLottie = styled(Lottie)`
  width: 184px;
  margin-bottom: -2.5px;

  @media ${({ theme }) => theme.media.smMax} {
    width: ${mixin.pxToVw('184')};
    margin-bottom: ${mixin.pxToVw('-2.5')};
  }
`;
